import Container from "../../common/Container";
import Header from "../../common/Header";
import Collections from "../../components/staking/Collections";
import RpcDropdown from "../../components/staking/RpcDropdown";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import { StakingWrapper } from "./styles";
import Protected from "../Protected";
import { useState } from "react";

const Staking = () => {
  const [isAuth, setAuth] = useState(false);
  return (
    <>
      <StakingWrapper>
        {/* <Navbar /> */}

        <Header />
        <Collections />
        <RpcDropdown />
      </StakingWrapper>
      {/* <Footer /> */}
    </>
  );
};

export default Staking;
